function dateOnlyInBangkok(value) {
  if (!value) return ''
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return validCivilDate(value) ? value : ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(date).map(({ type, value: part }) => [type, part]))
  const iso = `${parts.year}-${parts.month}-${parts.day}`
  return validCivilDate(iso) ? iso : ''
}
function validCivilDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(`${value}T00:00:00Z`)
  return year >= 1900 && year <= 9456 && !Number.isNaN(date.getTime()) &&
    date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && date.getUTCDate() === day
}
function nextContractStartDate(previousEndDate) {
  const civilDate = dateOnlyInBangkok(previousEndDate)
  if (!civilDate) return ''
  const date = new Date(`${civilDate}T00:00:00Z`)
  date.setUTCDate(date.getUTCDate() + 1)
  const iso = date.toISOString().slice(0, 10)
  return validCivilDate(iso) ? iso : ''
}
function contractYears(employeeType) {
  const type = String(employeeType || '').trim()
  if (type.includes('ตามภารกิจ')) return 3
  if (type.includes('ทั่วไป')) return 1
  return null
}
function defaultContractEndDate(startDate, employeeType) {
  const years = contractYears(employeeType)
  if (!validCivilDate(startDate) || !years) return ''
  const date = new Date(`${startDate}T00:00:00Z`)
  // Inclusive term: the day before the anniversary. Leap-day overflow gives 28 February.
  date.setUTCFullYear(date.getUTCFullYear() + years)
  date.setUTCDate(date.getUTCDate() - 1)
  const iso = date.toISOString().slice(0, 10)
  return validCivilDate(iso) ? iso : ''
}
module.exports = { dateOnlyInBangkok, nextContractStartDate, defaultContractEndDate, contractYears, validCivilDate }
